import styled, { css } from 'styled-components';

import { Sizes } from '../../../CheckBox/enums';
import DateRangePicker from '../../../DateRangePicker';

export const StyledDateRangePicker = styled(DateRangePicker)`
  &:not(:last-child) {
    ${({ size }) => {
      switch (size) {
        case Sizes.small:
          return css`
            margin-bottom: 14px;
          `;
        case Sizes.medium:
          return css`
            margin-bottom: 24px;
          `;
        default:
          return css`
            margin-bottom: 24px;
          `;
      }
    }}
  }
`;
